import { NgClass } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';

@Component({
  host: { '[style.--comments-container-offset]': 'containerOffset()' },
  selector: 'app-onboarding-comments-container',
  standalone: true,
  imports: [LinkComponent, NgClass],
  templateUrl: './onboarding-comments-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './onboarding-comments-container.component.scss'
})
export class OnboardingCommentsContainerComponent {

  title = input.required<string>();
  autoRefreshEnabled = input<boolean>(false);
  containerOffset = input<string>('3rem');

  closeClicked = output();
  toggleAutoRefreshClicked = output();

  close() {
    this.closeClicked.emit();
  }

  toggleAutoRefresh() {
    this.toggleAutoRefreshClicked.emit();
  }
}
